import { createAsyncAction, PayloadAction } from "typesafe-actions"
import { Dispatch } from "redux"
import {
  submitUnenrolledForm as apiSubmitUnenrolledForm,
  getToken as apiGetToken
} from "@theguarantors/frontend-core/dist/api/lg-questionnaire"

import { FormikActions } from "@theguarantors/frontend-core/dist/types/formik"
import { UnenrolledFormValues, UnenrolledFormValidationErrors } from "../pages/Unenrolled/UnenrolledPage.types"
import { submitFormWrapper } from "@theguarantors/frontend-core/dist/actions"
import { normalizeEmptyValues } from "@theguarantors/frontend-core/dist/utils/normalizeEmptyValues"

export const SUBMIT_FORM_REQUEST = "actions/unenrolledForm/submit/request"
export const SUBMIT_FORM_SUCCESS = "actions/unenrolledForm/submit/success"
export const SUBMIT_FORM_FAILURE = "actions/unenrolledForm/submit/failure"
export const SUBMIT_FORM_CANCEL = "actions/unenrolledForm/submit/cancel"

export const formSubmitAction = createAsyncAction(SUBMIT_FORM_REQUEST, SUBMIT_FORM_SUCCESS, SUBMIT_FORM_FAILURE, SUBMIT_FORM_CANCEL)<
  void,
  UnenrolledFormValues,
  string,
  void
>()

export const submitUnenrolledForm = (
  values: UnenrolledFormValues,
  { setErrors, setSubmitting }: FormikActions<UnenrolledFormValues>
) => async (dispatch: Dispatch<PayloadAction<string, void> | PayloadAction<string, string>>) => {
  await submitFormWrapper<UnenrolledFormValidationErrors>({
    formSubmitAction,
    dispatch,
    setSubmitting,
    setErrors,
    submit: async () => {
      const _csrf = await apiGetToken()
      await apiSubmitUnenrolledForm({
        _csrf,
        ...normalizeEmptyValues<UnenrolledFormValues>(values)
      })
      return values
    }
  })
}
